import { render, staticRenderFns } from "./SocketLog.vue?vue&type=template&id=626ffb38&"
import script from "./SocketLog.vue?vue&type=script&lang=js&"
export * from "./SocketLog.vue?vue&type=script&lang=js&"
import style0 from "./SocketLog.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/builds/queequegjones/rfWeatherClient/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib'
installComponents(component, {VFlex})
